(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template-mobile-featured"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    

    // Collection scroll-memory: stores in sessionStorage only (no URL params).
    // Saves Y + clicked product handle + loaded count, restores on return from
    // a product page. Auto-loads Ajaxinate pages if needed to reach the target.
    (function(){
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
      var KEY = 'cscroll:' + location.pathname + location.search;

      function loadedCount(){
        return document.querySelectorAll('#product-grid .grid__item').length;
      }
      function snapshot(extra){
        var data = {
          y: window.scrollY || window.pageYOffset || 0,
          lc: loadedCount(),
          t: Date.now()
        };
        if (extra) for (var k in extra) data[k] = extra[k];
        try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      }
      function read(){
        try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
      }
      function clear(){
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      }

      // Save on tap of a product link (more reliable on mobile than pagehide)
      function handleLinkTap(ev){
        var grid = document.getElementById('product-grid');
        if (!grid || !grid.contains(ev.target)) return;
        var a = ev.target.closest && ev.target.closest('a[href*="/products/"]');
        if (!a) return;
        if (a.target === '_blank' || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        var handle = m ? decodeURIComponent(m[1]) : null;
        snapshot({ handle: handle });
      }
      document.addEventListener('click', handleLinkTap, true);
      document.addEventListener('pointerdown', handleLinkTap, true);
      document.addEventListener('touchstart', handleLinkTap, { capture: true, passive: true });

      // Periodic save during scroll to capture position before navigation
      var ticking = false;
      window.addEventListener('scroll', function(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          snapshot();
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener('pagehide', function(){ snapshot(); });

      function shouldRestore(){
        // Restore ONLY when the user is genuinely returning from a product page.
        // Fresh visits (typed URL, ad click, link from outside) start at top.
        var fromProduct = document.referrer && document.referrer.indexOf('/products/') !== -1;
        var navType = '';
        try {
          var navs = performance.getEntriesByType && performance.getEntriesByType('navigation');
          navType = navs && navs[0] && navs[0].type || '';
        } catch (e) {}
        var isBackForward = navType === 'back_forward';
        return fromProduct || isBackForward;
      }

      function restore(){
        var data = read();
        if (!data) return;
        // Stale data > 10 min, treat as new session
        if (data.t && (Date.now() - data.t) > 10 * 60 * 1000) { clear(); return; }
        if (!shouldRestore()) { clear(); return; }

        function scrollToHandle(h){
          if (!h) return false;
          var safe = (window.CSS && CSS.escape) ? CSS.escape(h) : h.replace(/([^\w-])/g, '\\$1');
          var anchor = document.querySelector('#product-grid a[href*="/products/' + safe + '"]');
          if (!anchor) return false;
          var li = anchor.closest('li') || anchor.closest('.grid__item') || anchor;
          var y = li.getBoundingClientRect().top + (window.pageYOffset || 0);
          var header = document.querySelector('header.site-header, #shopify-section-header');
          if (header) y -= header.offsetHeight;
          window.scrollTo(0, Math.max(0, y));
          return true;
        }

        // Try handle anchor first (most reliable across re-paginated content)
        if (data.handle && scrollToHandle(data.handle)) {
          clear();
          return;
        }

        // If page is tall enough, scroll to saved Y
        var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        if (data.y && (docH - window.innerHeight) >= data.y - 50) {
          window.scrollTo(0, data.y);
          clear();
          return;
        }

        // Auto-load Ajaxinate pages until we can reach the target
        var pagi = document.querySelector('.AjaxinatePagination');
        if (!pagi) {
          if (data.y) window.scrollTo(0, data.y);
          clear();
          return;
        }
        var attempts = 0, maxAttempts = 30;
        function step(){
          if (data.handle && scrollToHandle(data.handle)) { clear(); return; }
          var dh = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
          if (data.y && (dh - window.innerHeight) >= data.y) {
            window.scrollTo(0, data.y);
            if (data.handle) scrollToHandle(data.handle);
            clear();
            return;
          }
          attempts++;
          if (attempts > maxAttempts) { clear(); return; }
          var p = document.querySelector('.AjaxinatePagination');
          var link = p && p.querySelector('a');
          var method = (p && p.getAttribute('data-pagination') || '').toLowerCase();
          if (link) {
            if (method === 'click') link.click();
            else { try { p.scrollIntoView({block:'end'}); } catch(_){} window.scrollTo(0, document.body.scrollHeight); }
          }
          setTimeout(step, 200);
        }
        setTimeout(step, 100);
      }

      // Try restore at multiple points — mobile paints async, so a single
      // attempt often misses (DOM not ready, header height not measured, etc.)
      function scheduleRestore(){
        restore();
        setTimeout(restore, 100);
        setTimeout(restore, 400);
        setTimeout(restore, 1000);
      }
      window.addEventListener('pageshow', scheduleRestore);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleRestore);
      } else {
        scheduleRestore();
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }

    // Collection scroll-memory: stores in sessionStorage only (no URL params).
    // Saves Y + clicked product handle + loaded count, restores on return from
    // a product page. Auto-loads Ajaxinate pages if needed to reach the target.
    (function(){
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
      var KEY = 'cscroll:' + location.pathname + location.search;

      function loadedCount(){
        return document.querySelectorAll('#product-grid .grid__item').length;
      }
      function snapshot(extra){
        var data = {
          y: window.scrollY || window.pageYOffset || 0,
          lc: loadedCount(),
          t: Date.now()
        };
        if (extra) for (var k in extra) data[k] = extra[k];
        try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      }
      function read(){
        try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
      }
      function clear(){
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      }

      function handleLinkTap(ev){
        var grid = document.getElementById('product-grid');
        if (!grid || !grid.contains(ev.target)) return;
        var a = ev.target.closest && ev.target.closest('a[href*="/products/"]');
        if (!a) return;
        if (a.target === '_blank' || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        var handle = m ? decodeURIComponent(m[1]) : null;
        snapshot({ handle: handle });
      }
      document.addEventListener('click', handleLinkTap, true);
      document.addEventListener('pointerdown', handleLinkTap, true);
      document.addEventListener('touchstart', handleLinkTap, { capture: true, passive: true });

      var ticking = false;
      window.addEventListener('scroll', function(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          snapshot();
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener('pagehide', function(){ snapshot(); });

      function shouldRestore(){
        // Restore ONLY when returning from a product page or back/forward.
        // Fresh visits (typed URL, ad click, external link) start at top.
        var fromProduct = document.referrer && document.referrer.indexOf('/products/') !== -1;
        var navType = '';
        try {
          var navs = performance.getEntriesByType && performance.getEntriesByType('navigation');
          navType = navs && navs[0] && navs[0].type || '';
        } catch (e) {}
        var isBackForward = navType === 'back_forward';
        return fromProduct || isBackForward;
      }

      function restore(){
        var data = read();
        if (!data) return;
        if (data.t && (Date.now() - data.t) > 10 * 60 * 1000) { clear(); return; }
        if (!shouldRestore()) { clear(); return; }

        function scrollToHandle(h){
          if (!h) return false;
          var safe = (window.CSS && CSS.escape) ? CSS.escape(h) : h.replace(/([^\w-])/g, '\\$1');
          var anchor = document.querySelector('#product-grid a[href*="/products/' + safe + '"]');
          if (!anchor) return false;
          var li = anchor.closest('li') || anchor.closest('.grid__item') || anchor;
          var y = li.getBoundingClientRect().top + (window.pageYOffset || 0);
          var header = document.querySelector('header.site-header, #shopify-section-header');
          if (header) y -= header.offsetHeight;
          window.scrollTo(0, Math.max(0, y));
          return true;
        }

        if (data.handle && scrollToHandle(data.handle)) {
          clear();
          return;
        }

        var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        if (data.y && (docH - window.innerHeight) >= data.y - 50) {
          window.scrollTo(0, data.y);
          clear();
          return;
        }

        var pagi = document.querySelector('.AjaxinatePagination');
        if (!pagi) {
          if (data.y) window.scrollTo(0, data.y);
          clear();
          return;
        }
        var attempts = 0, maxAttempts = 30;
        function step(){
          if (data.handle && scrollToHandle(data.handle)) { clear(); return; }
          var dh = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
          if (data.y && (dh - window.innerHeight) >= data.y) {
            window.scrollTo(0, data.y);
            if (data.handle) scrollToHandle(data.handle);
            clear();
            return;
          }
          attempts++;
          if (attempts > maxAttempts) { clear(); return; }
          var p = document.querySelector('.AjaxinatePagination');
          var link = p && p.querySelector('a');
          var method = (p && p.getAttribute('data-pagination') || '').toLowerCase();
          if (link) {
            if (method === 'click') link.click();
            else { try { p.scrollIntoView({block:'end'}); } catch(_){} window.scrollTo(0, document.body.scrollHeight); }
          }
          setTimeout(step, 200);
        }
        setTimeout(step, 100);
      }

      function scheduleRestore(){
        restore();
        setTimeout(restore, 100);
        setTimeout(restore, 400);
        setTimeout(restore, 1000);
      }
      window.addEventListener('pageshow', scheduleRestore);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleRestore);
      } else {
        scheduleRestore();
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.productlist-item')) {
      this.classList.add('product-recommendations--loaded');
      const swiperContainer = this.querySelector('.productlist-swiper');
      const sliderWrapper = this.querySelector('.productlist-wrapper');
      if (swiperContainer) {
        const sliderEffect = swiperContainer.getAttribute('data-slider-effect');
        const useFadeEffect = sliderEffect === 'fade';
        const spaceBetweenAttr = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
        let spaceBetween = Number.isNaN(spaceBetweenAttr) ? 0 : spaceBetweenAttr;
        let mobileSpaceBetween = 10;
        if (!Number.isNaN(spaceBetweenAttr)) {
          if (spaceBetween <= 0) {
            mobileSpaceBetween = 0;
          } else if (spaceBetween < mobileSpaceBetween) {
            mobileSpaceBetween = spaceBetween;
          }
        }
        const perviewDesktopValue = parseFloat(swiperContainer.getAttribute('data-perview-desktop'));
        const perviewMobileValue = parseFloat(swiperContainer.getAttribute('data-perview-mobile'));
        let desktopSlides = perviewDesktopValue > 0 ? perviewDesktopValue : 4;
        let mobileSlides = perviewMobileValue > 0 ? Math.min(perviewMobileValue, desktopSlides) : 1;
        let tabletSlides = Math.max(Math.ceil(perviewMobileValue || 1), 3);
        if (tabletSlides > desktopSlides) {
          tabletSlides = desktopSlides;
        }
        if (useFadeEffect) {
          desktopSlides = 1;
          mobileSlides = 1;
          tabletSlides = 1;
          spaceBetween = 0;
          mobileSpaceBetween = 0;
        }
        new Swiper(swiperContainer, {
          slidesPerView: desktopSlides,
          freeMode: false,
          autoHeight: true,
          calculateHeight:true,
          freeModeSticky: true,
          centeredSlides: false,
          grabCursor: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preloadImages: true,
          updateOnImagesReady: true,
          spaceBetween: spaceBetween,
          effect: useFadeEffect ? 'fade' : 'slide',
          fadeEffect: {
            crossFade: true
          },
          observer: true,
          observeParents: true,
          parallax:true,
          a11y: true,
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            0: {
              slidesPerView: useFadeEffect ? 1 : 'auto',
              centeredSlides: mobileSlides <= 1,
              centeredSlidesBounds: mobileSlides <= 1,
              spaceBetween: mobileSpaceBetween
            },
            576: {
              slidesPerView: mobileSlides,
              centeredSlides: mobileSlides <= 1,
              centeredSlidesBounds: mobileSlides <= 1
            },
            768: {
              slidesPerView: tabletSlides,
              centeredSlides: false,
              centeredSlidesBounds: false
            },
            992: {
              slidesPerView: desktopSlides,
              centeredSlides: false,
              centeredSlidesBounds: false,
              spaceBetween: spaceBetween
            }
          },
          scrollbar: {
            el: sliderWrapper ? sliderWrapper.querySelector(".swiper-scrollbar") : null,
          },
          navigation: {
            nextEl: sliderWrapper ? sliderWrapper.querySelector(".swiper-button-next") : null,
            prevEl: sliderWrapper ? sliderWrapper.querySelector(".swiper-button-prev") : null,
          },
        });
      } else {
        console.error('No element with class "productlist-swiper" found.');
      }
    }
    try { if (typeof jdgm !== 'undefined' && jdgm && typeof jdgm.customizeBadges === 'function') jdgm.customizeBadges(); } catch(e) { console.warn('jdgm.customizeBadges skipped:', e); }
    try {
      if (window.SPR && typeof theme !== 'undefined' && theme.review) {
        if (typeof $ === 'function' && $('.shopify-product-reviews-badge').length > 0) {
          window.SPR.registerCallbacks();
          window.SPR.initRatingHandler();
          window.SPR.initDomEls();
          window.SPR.loadProducts();
          window.SPR.loadBadges();
        }
      }
    } catch(e) { console.warn('SPR init skipped:', e); }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};
// expose for external triggers (e.g. collage thumbs)
window.openPhotoSwipe = openPhotoSwipe;

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-2"]) return;
  try {
    
(function(){
  var wrapper = document.getElementById('RecentlyViewed2-{{ section.id }}');
  if (!wrapper) return;

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem('localRecentlyViewed')) || [];
    } catch(e) {
      return [];
    }
  }

  var tries = 0;

  function initFromStorage() {
    var handles = getHandles();
    if (!handles.length) {
      if (tries < 3) {
        tries += 1;
        setTimeout(initFromStorage, 300);
        return;
      }
      wrapper.closest('.section-{{ section.id }}-padding')?.remove();
      return;
    }

    var limit = parseInt(wrapper.dataset.limit, 10) || handles.length;
    var perviewDesktop = parseFloat(wrapper.dataset.perviewDesktop) || 4;
    var perviewMobile = parseFloat(wrapper.dataset.perviewMobile) || 2;
    var perviewMobileSmall = parseFloat(wrapper.dataset.perviewMobileSmall) || perviewMobile;
    var spaceBetween = parseInt(wrapper.dataset.spaceBetween, 10);
    if (isNaN(spaceBetween)) { spaceBetween = 0; }
    var sizeImage = wrapper.dataset.sizeImage || '';
    var enableArrows = wrapper.dataset.arrows === 'true';
    var enableScrollbar = wrapper.dataset.scrollbar === 'true';

    var swiperContainer = wrapper.querySelector('.productlist-swiper');
    var swiperWrapper = wrapper.querySelector('.js-recently-view-2');
    if (!swiperContainer || !swiperWrapper) return;

    function buildSlide(product){
      var featured = product.featured_image || {};
      var imageSrc = featured.src || product.featured_image || '';
      var aspectRatio = featured.aspect_ratio || (featured.width && featured.height ? featured.width / featured.height : 1);
      var paddingTop = aspectRatio ? (1 / aspectRatio * 100).toFixed(2) : 100;
    var productPrice = product.price_varies ? theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat);
    var productComparePrice = product.compare_at_price_min && product.compare_at_price_min > product.price_min ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '';
    var hasSale = Boolean(productComparePrice);
    var salePercent = 0;
    if (hasSale) {
      var diff = product.compare_at_price_min - product.price_min;
      salePercent = Math.floor((diff / product.compare_at_price_min) * 100);
    }
    var priceHtml = '<div class="product-card__price ' + (hasSale ? 'product-card__pricesale' : '') + '">';
    if (hasSale) {
      priceHtml += '<span class="product-card__price-current">' + productPrice + '</span>';
      priceHtml += '<s class="product-card__regular-price">' + productComparePrice + '</s>';
    } else {
      priceHtml += '<span class="product-card__price-current">' + productPrice + '</span>';
    }
    priceHtml += '</div>';
    var saleBadge = '';
    if (hasSale && salePercent > 0) {
      saleBadge = '<div class="product-tag product-tag-sale-item product-tag--absolute" aria-hidden="true">' + salePercent + '% OFF</div>';
    }

    var typeText = product.type ? '<div class="product-card__type">' + product.type + '</div>' : '';

      var html = document.createElement('div');
      html.className = 'productlist-item swiper-slide';
      html.innerHTML = `
      <div class="product-card js-product-card product-card--style1 h-100 text-left" data-price="${product.price}">
        <div class="product-card__image-wr position-relative">
          ${saleBadge}
          <a class="product-card__image js image-content__image-wrapper ${sizeImage}" href="${product.url}" style="padding-top:${paddingTop}%">
            <img class="lazyload scale-in first-image" loading="lazy" src="${imageSrc}&width=360" data-src="${imageSrc}&width=720" alt="${product.title}">
          </a>
        </div>
        <div class="product-card__info">
          ${typeText}
          <a class="d-block product-card__name" href="${product.url}">${product.title}</a>
          ${priceHtml}
        </div>
      </div>`;
    swiperWrapper.appendChild(html);
    }

    var list = handles.slice(Math.max(handles.length - limit, 0));

    function fetchProduct(handle){
      return new Promise(function(resolve){
        if (typeof Shopify !== 'undefined' && typeof Shopify.getProduct === 'function') {
          Shopify.getProduct(handle, function(product){
            resolve(product);
          });
        } else {
          fetch('/products/' + handle + '.js')
            .then(function(res){ return res.json(); })
            .then(function(product){ resolve(product); })
            .catch(function(){ resolve(null); });
        }
      });
    }

    var requests = list.map(function(handle){
      return fetchProduct(handle).then(function(product){
        if (product) {
          buildSlide(product);
        }
      });
    });

    Promise.all(requests).then(function(){
      if (!swiperWrapper.children.length) {
        wrapper.closest('.section-{{ section.id }}-padding')?.remove();
        return;
      }
      var mobileSpaceBetween = spaceBetween;
      if (spaceBetween <= 0) {
        mobileSpaceBetween = 0;
      } else if (spaceBetween < 10) {
        mobileSpaceBetween = spaceBetween;
      } else {
        mobileSpaceBetween = Math.min(spaceBetween, 16);
      }

      new Swiper(swiperContainer, {
        slidesPerView: perviewDesktop,
        freeMode: false,
        autoHeight: true,
        calculateHeight:true,
        freeModeSticky: true,
        centeredSlides: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preloadImages: true,
        updateOnImagesReady: true,
        spaceBetween: spaceBetween,
        observer: true,
        observeParents: true,
        parallax:true,
        a11y: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          0: {
            slidesPerView: perviewMobileSmall,
            centeredSlides: perviewMobileSmall < 2,
            centeredSlidesBounds: perviewMobileSmall < 2,
            spaceBetween: mobileSpaceBetween
          },
          576: {
            slidesPerView: perviewMobile,
            centeredSlides: perviewMobile <= 1,
            centeredSlidesBounds: perviewMobile <= 1
          },
          768: {
            slidesPerView: Math.min(Math.max(Math.ceil(perviewMobile), 3), perviewDesktop),
            centeredSlides: false,
            centeredSlidesBounds: false
          },
          992: {
            slidesPerView: perviewDesktop,
            centeredSlides: false,
            centeredSlidesBounds: false,
            spaceBetween: spaceBetween
          }
        },
        scrollbar: enableScrollbar ? { el: swiperContainer.querySelector(".swiper-scrollbar") } : {},
        navigation: enableArrows ? {
          nextEl: wrapper.querySelector(".swiper-button-next"),
          prevEl: wrapper.querySelector(".swiper-button-prev"),
        } : {}
      });
    });
  }

  // wait for DOM ready to give other scripts a chance to populate storage
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromStorage);
  } else {
    initFromStorage();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
